import { render } from "./Home.vue?vue&type=template&id=15be4bdd&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=15be4bdd&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-15be4bdd"

export default script